import React from "react";

const AnimatedMessage: React.FC<{ message: string }> = ({ message }) => (
	<div className="conversation-content conversation-left conversation-left-top animated fadeInUpSmall animation-delay-first">
		{message}
	</div>
);

export default AnimatedMessage;
